
const AppConfig = {
    appVersion: '0.0.1',
    oauth: true
};

export const APP_CONFIG = AppConfig;
